import React, { useEffect, useState } from "react";
import {
  TextField,
  InputAdornment,
  styled,
  Box,
  Typography,
} from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import VerifyOtp from "./VerifyOtp";
import InputField from "./InputField";
import { formatTime } from "../../utils/formatTime";
import { api, post } from "../../utils/api";

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px",
  },
}));

const PhoneFieldInput = ({
  title,
  value,
  fieldName,
  placeholder,
  element,
  countryCode,
  setFormData,
  formData,
  showIcon,
  setErrors,
  errors,
  handleChange,
}) => {
  const [otp, setOTP] = useState({ phone: "" });
  const [timerPhone, setTimerPhone] = useState(120);
  const [timerActive, setTimerActive] = useState({ phone: false });

  // Timer logic
 

//   const handleInputChange = (event) => {
//     const inputValue = event.target.value;
//     if (/^\d{0,10}$/.test(inputValue)) {
//       handlePhoneChange(event);
//     }
//   };

  const handlePhoneChange = (e) => {
    const { value } = e.target;

    // Reset related states
    console.log(value,formData,"f1")
    setErrors((prev) => ({
      ...prev,
      contactNumber: "",
      contactPersonName: "",
    }));

    if (formData?.contactNumber?.countryCode === "" || formData?.countryCode==="") {
      setErrors((prev) => ({
        ...prev,
        contactNumber: "Please Select Country.",
      }));
      return;
    }

    setOTP((prevOtp) => ({
      ...prevOtp,
      phone: "",
    }));

    const phoneNumberPattern = /^[0-9]{0,10}$/;
    if (!phoneNumberPattern.test(value)) {
    //   setErrors((prev) => ({
    //     ...prev,
    //     contactNumber: "Please Enter 0 - 9 digit only.",
    //   }));
      return;
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      contactNumber: {
        ...prevFormData.contactNumber,
        mobileNo: value,
      },
    }));
  };


  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
        {title}
      </Typography>
      <CustomTextField
        variant="outlined"
        fullWidth
        value={value}
        name={fieldName}
        placeholder={placeholder}
        onChange={handleChange?handleChange:handlePhoneChange}
        // disabled={disable}
        InputProps={{
          maxLength: 10,
          inputMode: "numeric",
          pattern: "[0-9]*",
        //   endAdornment: showIcon && <TaskAltIcon sx={{ color: "green" }} />,
          startAdornment: (
            <InputAdornment position="start">
              <div
                style={{
                  width: "40px",
                  marginRight: "8px",
                  fontWeight: "bold",
                }}
              >
                {countryCode || "code"}
              </div>
              <div
                style={{
                  borderRight: "1px solid #000",
                  height: "24px",
                  marginRight: "8px",
                }}
              />
            </InputAdornment>
          ),
        }}
      />
      {errors && (
        <Typography variant="body2" color="#D34040">
          {errors}
        </Typography>
      )}
    
    </Box>
  );
};

export default PhoneFieldInput;
